import { LevelConstants } from "../constants/LevelConstants";

export function convertLevelString(level: string): string {
  switch (level) {
    case "e1":
      level = LevelConstants.ENTRY_1;
      break;
    case "e2":
      level = LevelConstants.ENTRY_2;
      break;
    case "e3":
      level = LevelConstants.ENTRY_3;
      break;
    case "l1":
      level = LevelConstants.LEVEL_1;
      break;
    case "l2":
      level = LevelConstants.LEVEL_2;
      break;
    case "l3":
      level = LevelConstants.LEVEL_3;
      break;
    default:
      level = LevelConstants.NO_LEVEL;
      break;
  }
  return level;
}
